<template>
	<div class="full">
		<el-container class="full" v-loading="loading">
			<el-container >
				<el-aside class="aside" width="200px">
					<shoptree @select="nodeChange" />
				</el-aside>
				<el-container>
					<el-header style="height: 40px;">
						<div style="display: inline-block;margin-top: 20px;">
							<el-switch  v-model="showFlowup" @change="flowupChange" active-text="只显示自己跟踪" inactive-text=""></el-switch>
						</div>	
					</el-header>
					<el-main style="padding: 10px;">
						<div class="table flex">
							<div style="margin: 10px 0;" v-if="grouptype=='operation'">
								<el-row :gutter="20">
									<el-col :span="4">
										<div>
											<el-statistic group-separator="," :precision="2" :value="staticdata.payAmt" title="总销售额">
												<template slot="suffix" v-if="staticdata.payAmtkpi">
													<el-tooltip class="item" effect="dark" :content="'销售额目标：'+staticdata.payAmtkpi" placement="top-start">
														<span style="color: #F56C6C;font-size: 12px;">{{'/ 已完成：'+staticdata.payAmtprocess+'%'}}</span>
													</el-tooltip>
												</template>												
											</el-statistic>
										</div>
									</el-col>
									<el-col :span="4">
										<div>
											<el-statistic group-separator="," :precision="2" :value="staticdata.charge"
												title="总花费"></el-statistic>
										</div>
									</el-col>
									<el-col :span="4">
										<div>
											<el-statistic group-separator="," :precision="0" :value="staticdata.payTotalByrCnt"
												title="总付款人数"></el-statistic>
										</div>
									</el-col>
									<el-col :span="4">
										<div>
											<el-statistic group-separator="," :precision="0" :value="staticdata.itmUv"
												title="总访客"></el-statistic>
										</div>
									</el-col>
									<el-col :span="4">
										<div>
											<el-statistic group-separator="," :precision="2" :value="staticdata.payRate"
												title="支付转化率(%)"></el-statistic>
										</div>
									</el-col>
									<el-col :span="4">
										<div>
											<el-statistic group-separator="," :precision="2" :value="staticdata.chargePercent"
												title="付费占比(%)"></el-statistic>
										</div>
									</el-col>
								</el-row>
							</div>
							<div style="position: relative;flex: 1;">
								<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions" ref="bishopgoods"
									@toolbar-button-click="list_toolbarButtonClickEvent" @cell-click="cellClick"></vxe-grid>
							</div>
						</div>
						<div class="footer">
							<operateIndex :row="currentrow" />
						</div>
					</el-main>
				</el-container>
			</el-container>
		</el-container>
		<singleIndex :currentrow="currentrow" ref="singleIndex"  />
		<costdetail :currentrow="currentrow" ref="costdetail" />
		<competitive-index ref="competitiveIndex" />
	</div>
</template>
<style>

</style>
<style scoped>
	.table {
		position: relative;
		width: 100%;
		height: 70%;
		flex-direction: column;
	}

	.footer {
		position: relative;
		width: 100%;
		height: 30%;
	}
</style>
<script>
	
	
	//import listBase from '@_system/components/base/list.vue'
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import operateIndex from './operate/index.vue'
	import singleIndex from './single/index.vue'
	import shoptree from './shoptree/index.vue'
	import costdetail from './costdetail/index.vue'
	import competitiveIndex from './competitive/index.vue'
	
	export default {
		mixins: [listMixins],
		name: 'bi',
		props: {

		},
		data() {
			let datetime = [this.$Moment().startOf('month').valueOf(),this.$Moment().startOf('day').valueOf()]
			return {
				moduleName:'shopgoodsnew',
				showFlowup:false,
				parcentField:['payAmt','sucRefundAmt','newPayByrCnt','payOldByrCnt','payTotalByrCnt','payRate','itmUv','seGuideUv','seGuidePayByrCnt','seGuidePayRate','uvValue','payPct','charge','chargePercent'],
				loading: false,
				tableData: [],
				historytableData:[],
				childrenRow: null,
				selectTab: '',
				shopnameOptions: [],
				formField: {
					shopname: [],
					psnNickName: [],
					code: '',
					title: ''
				},
				list_formConfig: [{
					field: 'shopname',
					title: '店铺名称',
					itemRender: {
						name: '$select',
						props:{
							selectoptions:[
								{label:'[天猫]劲功旗舰店',value:'[天猫]劲功旗舰店'},
								{label:'[天猫]安捷顺宇皓专卖店',value:'[天猫]安捷顺宇皓专卖店'},
								{label:'[天猫]sj旗舰店',value:'[天猫]sj旗舰店'},
							]
						}
					}
					// slots:{
					// 	default:(params)=>{
					// 		return <el-cascader v-model={params.data.shopname} size="mini" collapse-tags options={this.shopnameOptions} show-all-levels={false} props={{multiple: true, checkStrictly: false}} clearable></el-cascader>
					// 	}
					// }
				},{
					field: 'code',
					title: '商品编码',
					itemRender: {
						name: '$input'
					}
				},{
					field: 'title',
					title: '商品名称',
					itemRender: {
						name: '$input'
					}
				},{
					field: 'datetime',
					title: '日期',
					resetValue:datetime,
					itemRender: {
						name: '$datePicker',
						defaultValue:datetime,
					}
				}],
				currentrow:null,
				other:{},
				groupid:-2,
				grouptype:'operation',
				staticdata:{
					charge:0,
					itmUv:0,
					payAmt:0,
					payAmtkpi:0,
					payAmtprocess:0,
					payRate:0,
					payTotalByrCnt:0,
					chargePercent:0,
				}
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			// this.gridOptions = this.getOption()
			// console.log(this.gridOptions)
		},
		computed: {

		},
		methods: {
			customreload(){
				this.$refs.bishopgoods.commitProxy('query')
			},
			competitive(){
				this.$refs.competitiveIndex.modal_show()
			},
			nodeChange(e){
				console.log(e)
				if(e.grouptype=='shop'){
					this.groupid = e.shopUid
				}else{
					this.groupid = e.id
				}
				
				this.grouptype = e.grouptype
				this.customreload()
			},
			list_beforeCreateGrid(gridOptions) {
				//gridOptions.height = 550
				gridOptions.id = 'bIshopgoods'
				gridOptions.showOverflow = false
				gridOptions.columns = this.getColumns()
				gridOptions.exportConfig = {
					name: '导出',
					type: 'xlsx',
					exportMethod:this.exportMethod,
					remote:true
				}
				gridOptions.toolbarConfig.buttons = [{
					name: '导出',
					status: 'success',
					code: 'export'
				},{
					name: '竞品穿透',
					status: 'danger',
					code: 'competitive'
				}]
				
				// gridOptions.scrollY = {
				// 	enabled:false
				// }
				gridOptions.tooltipConfig.contentMethod = this.contentMethod
				gridOptions.pagerConfig = {
					autoHidden: false,
					border: true,
					size: 'mini',
					perfect: false,
					currentPage: 1,
					pageSize: 20,
					pageSizes: [10, 20, 50, 100, 200, 500, 5000],
				}
			},
			exportMethod(e){
				return new Promise((resolve) => {
					let options = JSON.parse(JSON.stringify(e.options))
					let fullData = JSON.parse(JSON.stringify(this.sourceData))
					fullData.forEach((item)=>{
						item.type = null
					})
					options.remote = false
					options.data = fullData
					this.$refs.bishopgoods.exportData(options)
					resolve()
					
					
					// let pager = e.$grid.getProxyInfo().pager				
					// this.$api.BIshopgoods.export({
					// 	currentPage:-1,
					// 	pageSize:pager.pageSize
					// }).then((res)=>{
					// 	let options = JSON.parse(JSON.stringify(e.options))
					// 	res.tableData.forEach((item)=>{
					// 		item.type = null
					// 	})
					// 	options.data = res.tableData
					// 	options.remote = false
					// 	this.$refs.bishopgoods.exportData(options)
					// 	resolve()
					// })
				});
				
			},
			list(page, updateForm) {

				return new Promise((resolve) => {
					this.getstatic(updateForm)
					this.$api.BIshopgoods.get({
						...page,
						...updateForm,
						...this.other,
						...{
							demo:1,
							groupid:this.groupid,
							grouptype:this.grouptype,
						}
					}).then((res) => {
						res.tableData.forEach((item) => {
							item.payPct = 0
							if (item.payTotalByrCnt) {
								item.payPct = (item.payAmt / item.payTotalByrCnt).toFixed(2)
							}
							item.itemCost = item.costdetail?item.costdetail.itemCost:0
							item.tp_payment = item.costdetail?item.costdetail.tp_payment:0
							
							item.exchangeitemCost = item.exchangecostdetail?item.exchangecostdetail.itemCost:0
							item.receivable_fee = item.exchangecostdetail?item.exchangecostdetail.receivable_fee:0
							
							item.itemCost = item.itemCost - item.exchangeitemCost
							item.tp_payment = item.tp_payment - item.receivable_fee
							
							item.itemCost = item.itemCost?item.itemCost.toFixed(2):null
							item.tp_payment = item.tp_payment?item.tp_payment.toFixed(2):null
							
						})
						res.historytableData.forEach((item) => {
							item.payPct = 0
							if (item.payTotalByrCnt) {
								item.payPct = (item.payAmt / item.payTotalByrCnt).toFixed(2)
							}
						
						})
						this.sourceData = JSON.parse(JSON.stringify(res.tableData))
						this.historytableData = res.historytableData
							
						this.shopnameOptions = res.formField.shopname
						console.log(this.shopnameOptions)
						if (this.shopnameOptions.length != 0) {
							this.selectTab = this.shopnameOptions[0].value
						}
						let list = this.createTableData()
						list.forEach((item)=>{
							let percentinfo = {}
							this.parcentField.forEach((_item)=>{
								percentinfo[_item] = this.getpercent(item,_item)
							})
							item.percent = percentinfo
						})
				
						this.currentrow = null
						resolve({
							list: list,
							total: res.total
						})
					}, () => {
						resolve()
					})
				})
			},

			getstatic(updateForm) {
				this.$api.BIshopgoods.get({
					...updateForm,
					...this.other,
					...{
						demo:1,
						static:1,
						groupid:this.groupid,
						grouptype:this.grouptype,
					}
				}).then((res) => {
					//console.log(res,12312312312)
					for(let i in this.staticdata){
						this.staticdata[i] = res[i]?res[i]:0
					}
				}, () => {
	
				})
			},
			contentMethod({row,column}){
				if(row && this.parcentField.indexOf(column.field)!==-1){
					return '本周期：' + row[column.field] + '\n上周期：'+row.percent[column.field].value + '\n浮动：'+row.percent[column.field].text
				}else{
					return null
				}
				
			},
			cellClick({row,column}){
				if(column.field){
					this.currentrow = row
					if(column.field=='code'){
						this.$nextTick(()=>{
							this.$refs.singleIndex.drawer_show()
						})
					}
				}
			},
			flowupChange(e){
				this.other.showFlowup = e?1:0
				this.customreload()
			},
			getColumns() {
				let columns = [{
						field: 'shopname',
						title: '店铺',
						width:100,
						fixed:'left',
						sortable: true,
						showOverflow:true,
					},
					{
						field: 'code',
						title: '商品编码',
						fixed:'left',
						width:150,
						slots : {
							default: ({row}) => {									
								//let currenttime = new Date().getTime()/1000
								let str = []
								if(row.needflowuptime == 1){
									str.push(<el-tag size="mini" type="danger" effect="dark" style="margin-right: 2px;">跟</el-tag>)
								}
								str.push(<el-link style="font-size:12px;" type="primary">{row.code}</el-link>)
								return str
							}
						}
					},
					{
						field: 'title',
						title: '名称',
						width:150,
						sortable: true,
						showOverflow:true,
					},
					{
						field: 'payAmt',
						title: '支付金额',
						width:100,
						sortable: true
					},
					{
						
						field: 'sucRefundAmt',
						title: '成功退款金额',
						width:100,
						sortable: true,
					},
					{
						field: 'newPayByrCnt',
						title: '支付新买家数',
						width:100,
						sortable: true
					},
					{
						field: 'payOldByrCnt',
						title: '支付老买家数',
						width:100,
						sortable: true
					},
					
					{
						field: 'payTotalByrCnt',
						title: '支付总人数',
						width:100,
						sortable: true
					},
					{
						field: 'payRate',
						title: '支付转化率',
						width:100,
						sortable: true
					},
					{
						field: 'itmUv',
						title: '商品访客数',
						width:100,
						sortable: true
					},
					{
						field: 'seGuideUv',
						title: '搜索访客数',
						width:100,
						sortable: true
					},
					{
						field: 'seGuidePayByrCnt',
						title: '搜索支付买家数',
						width:100,
						sortable: true
					},
					{
						field: 'seGuidePayRate',
						title: '搜索支付转化率',
						width:100,
						sortable: true,
						formatter: ({
							cellValue
						}) => {
							return cellValue + '%'
						}
					},
					{
						field: 'uvValue',
						title: 'UV价值',
						width:100,
						sortable: true
					},
					{
						field: 'payPct',
						title: '客单价',
						width:100,
						sortable: true
					},
					{
						field: 'charge',
						title: '花费',
						width:100,
						sortable: true,
					},
					{
						field: 'chargePercent',
						title: '付费占比',
						width:100,
						sortable: true,
						formatter: ({
							cellValue
						}) => {
							return cellValue + '%'
						}
					},
					{
						field: 'tp_payment',
						title: '万里牛净销售额',
						width:100,
						fixed:'right',
						sortable: true,
						slots: {
							default:({row})=>{
								return	<div>
									<div style="font-weight:bolder;display:inline-block;font-size:14px">{row.tp_payment}</div>
								</div>
							}
						}
					},
					{
						field: 'itemCost',
						title: '万里牛成本',
						width:100,
						fixed:'right',
						sortable: true,
						slots: {
							default:({row})=>{
								return	<div>
									<div style="font-weight:bolder;display:inline-block;font-size:14px">{row.itemCost}</div>
								</div>
							}
						}
					},		
					{
						field: 'flowuptime',
						title: '最近跟踪时间',
						width:100,
						fixed:'right',
						formatter: ({
							cellValue
						}) => {
							return window.systemMethods.timestampToDate(cellValue,true)
						},
						sortable:true
					},
					{
						field: 'payAmtkpi',
						title: '销售额KPI',
						width:100,
						fixed:'right',
						formatter: ({
							cellValue
						}) => {
							return cellValue?cellValue:null
						},
						sortable:true
					},
					{
						field: 'payAmtprocess',
						title: '销售额完成度',
						width:100,
						fixed:'right',
						formatter: ({
							row
						}) => {
							return row.payAmtkpi?(row.payAmt/row.payAmtkpi*100).toFixed(2) + '%':null
						},
						sortable:true
					},
					{
						field: '',
						title: '操作',
						width: 120,
						fixed: "right",
						align: 'center',
						slots: {
							default:({row})=>{
								return	[
										<el-button size="mini" type="text" onClick={()=>{this.costdetail(row)}}>详情</el-button>,
										<el-button size="mini" type="text" style="color:#F56C6C;" onClick={()=>{this.deleteitemtogroup(row)}}>移除分组</el-button>,
										
									]
							}
						}
					},
					//{field:'date',title:'日期',sortable:true},
				]
				columns.forEach((item)=>{
					item.showHeaderOverflow = 'tooltip'
					if(this.parcentField.indexOf(item.field)!==-1){
						item.slots = {
							default:({row})=>{
								return	<div>
									<div style="font-weight:bolder;display:inline-block;font-size:14px">{row[item.field]}</div>
									<div style={{color:row.percent[item.field].color}}>{row.percent[item.field].text}</div>
								</div>
							}
						}
					}
				})
				return columns
			},
			costdetail(row){
				this.currentrow = row
				this.$refs.costdetail.modal_show()
			},
			deleteitemtogroup(row){
				this.$confirm('是否确认移除分组').then(()=>{
					this.$api.BIshopgoods.deleteitemtogroup({
						goodscode: row.code
					}).then(() => {
						this.customreload()
						this.$message.success('操作成功')
					})
				})
			},
			getpercent(row,field){
				let percent = ''
				let obj = this.historytableData.find((item)=>{
					return item.code == row.code
				})
				if(obj){
					if(obj[field]){
						percent = ((parseFloat(row[field]) - parseFloat(obj[field]))/obj[field]*100).toFixed(2)
					}	
				}
				percent = !isNaN(percent)?percent:''
				let result = {
					value:obj?obj[field]:0,
					percent:percent?Math.abs(percent):'',
					type:percent?(percent>0?'up':'down'):'none',
					color:percent?(percent>0?'#F56C6C':'#67C23A'):'none'
				}
				if(result.type=='up'){
					result.text = '↑ ' + result.percent+'%'
				}
				if(result.type=='down'){
					result.text = '↓ ' + result.percent+'%'
				}				
				return result
			},
			// getProx() {
			// 	let proxyConfig = {
			// 		ajax: {
			// 			query: ({
			// 				page,
			// 			}) => {
			// 				let updateForm = JSON.parse(JSON.stringify(this.formData))
			// 				for (let i in updateForm) {
			// 					if (i.match(/.*time$/g)) {
			// 						if (typeof updateForm[i] === 'string') {
			// 							updateForm[i] = updateForm[i].split(',')
			// 						}
			// 						if (typeof updateForm[i] === 'number') {
			// 							if (updateForm[i] > 1000000000000) {
			// 								updateForm[i] = updateForm[i] / 1000
			// 							}
			// 						} else if (Array.isArray(updateForm[i])) {
			// 							let timerange = updateForm[i]
			// 							timerange.forEach((t, i) => {
			// 								if (t > 1000000000000) {
			// 									timerange[i] = t / 1000
			// 								} else {
			// 									timerange[i] = t
			// 								}

			// 							})
			// 							updateForm[i] = updateForm[i].join(',')
			// 						}
			// 					} else {
			// 						if (Array.isArray(updateForm[i])) {
			// 							updateForm[i] = updateForm[i].join(',')
			// 						}
			// 					}
			// 				}
			// 				return new Promise(resolve => {
			// 					this.$api.BIshopgoods.get({
			// 						...page,
			// 						...updateForm
			// 					}).then((res) => {
			// 						res.tableData.forEach((item) => {
			// 							item.payPct = 0
			// 							if (item.payTotalByrCnt) {
			// 								item.payPct = (item.payAmt / item
			// 									.payTotalByrCnt).toFixed(2)
			// 							}

			// 						})
			// 						this.sourceData = res.tableData
			// 						this.shopnameOptions = res.formField.shopname
			// 						if (this.shopnameOptions.length != 0) {
			// 							this.selectTab = this.shopnameOptions[0].value
			// 						}

			// 						let resolveobj = {
			// 							result: this.createTableData(),
			// 							page: {
			// 								total: res.total
			// 							}
			// 						}
			// 						resolve(resolveobj)
			// 					}, () => {
			// 						resolve()
			// 					})
			// 				})
			// 			}
			// 		}
			// 	}
			// 	return proxyConfig

			// },
			createTableData() {
				let tableData = JSON.parse(JSON.stringify(this.sourceData))
				return tableData
			},
			submitEvent() {
				this.customreload()
			},
			reset() {
				for (let i in this.formData) {
					this.formData[i] = null
				}
				this.$refs.shopgoods.getProxyInfo().pager.currentPage = 1
				this.customreload()

			},
			href(url) {
				window.location.href = url
			}
		},
		components: {
			operateIndex,
			singleIndex,
			shoptree,
			costdetail,
			competitiveIndex
		}
	}
</script>